/* eslint-disable default-case, no-param-reassign, consistent-return */
/*
 *
 * Fees reducer
 *
 */

import produce from 'immer';
import isEmpty from 'lodash/isEmpty';

import {
  FETCH_FEES,
  FETCH_FEES_FAILURE,
  FETCH_FEES_SUCCESS,
  SET_PREAUTH_FEE_SCHEDULES,
} from './constants';

export const initialState = {
  asOfDate: '',
  disclaimer: [],
  feeSchedule: [],
  feeStatement: '',
  preauthFeeStatements: [],
  requestStatus: { fees: 'idle' },
};

const feesReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case FETCH_FEES: {
      draft.asOfDate = initialState.asOfDate;
      draft.disclaimer = initialState.disclaimer;
      draft.feeSchedule = initialState.feeSchedule;
      draft.feeStatement = initialState.feeStatement;
      draft.preauthFeeStatements = initialState.preauthFeeStatements;
      draft.requestStatus.fees = 'loading';
      break;
    }
    case FETCH_FEES_FAILURE: {
      const {
        asOfDate,
        disclaimer,
        feeSchedule,
      } = payload;
      draft.asOfDate = asOfDate;
      draft.disclaimer = disclaimer;
      draft.feeSchedule = feeSchedule;
      draft.feeStatement = initialState.feeStatement;
      draft.requestStatus.fees = 'failed';
      break;
    }
    case FETCH_FEES_SUCCESS: {
      const { statementUrl } = payload;
      // this is for postauth login fee schedules
      if (statementUrl) {
        draft.feeStatement = statementUrl;
      } else {
        const {
          asOfDate,
          disclaimer,
          feeSchedule,
        } = payload;
        draft.asOfDate = asOfDate;
        draft.disclaimer = disclaimer;
        draft.feeSchedule = feeSchedule;
      }
      draft.requestStatus.fees = 'succeeded';
      break;
    }
    case SET_PREAUTH_FEE_SCHEDULES: {
      const { feeStatements } = payload;
      const requestStatus = isEmpty(feeStatements) ? 'failed' : 'succeeded';
      draft.preauthFeeStatements = feeStatements;
      draft.feeStatement = initialState.feeStatement;
      draft.requestStatus.fees = requestStatus;
      break;
    }
  }
}, initialState);

export default feesReducer;
